import {AsyncDataLoading} from '@frontend/components/AsyncDataLoading'
import {trans} from '@frontend/helpers'
import type {FilteredItemsPageUrlQueryParams} from '@frontend/modules/public/ads/AdsModuleTypes'
import {useFilteredItemsLoader} from '@frontend/modules/public/ads/hooks/useFilteredItemsLoader'
import {ServicesList} from '@frontend/modules/public/services/components/list/ServicesList'
import type {ExecutorPreviewData} from '@frontend/modules/public/services/ServicesModuleTypes'
import {useEffect} from 'react'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'

interface Props {
    categoryId: number | null
    filters: Partial<FilteredItemsPageUrlQueryParams>
    // Количество услуг на странице:
    // Рекомендуемое количество: 5-10.
    pageLimit?: number
}

// Список услуг для страницы поиска услуг.
export function ServicesFromOtherLocations(props: Props) {

    const {
        categoryId,
        filters,
        pageLimit = 10,
    } = props

    const {
        loadItems,
        isLoading,
        items,
        totalItemsCount,
        loadingError,
        isAllItemsLoaded,
        onItemDataChange,
    } = useFilteredItemsLoader<ExecutorPreviewData>({
        type: 'services',
        listIdForAnalytics: 'from_other_locations',
        categoryId,
        filters: {
            ...filters,
            location: null,
            exceptLocation: filters.exceptLocation ?? filters.location ?? null,
        },
        pageLimit,
    })

    // Загрузка объявлений при изменении фильтров (включая монтирование).
    useEffect(() => {
        loadItems('filter')
    }, [categoryId, JSON.stringify({...filters, location: null})])

    // Если нет объявлений в других локациях - не показываем этот блок вообще.
    if (totalItemsCount === 0) {
        return null
    }

    return (
        <AsyncDataLoading
            loading={isLoading !== null && isLoading !== 'next'}
            className="flex-1"
            error={loadingError}
            onReload={() => loadItems('filter')}
            render={() => (
                <div id="executors-from-other-locations">
                    <h2 className="my-4 d-flex flex-row justify-content-start align-items-center">
                        {trans().services.list.services_from_other_locations}
                        <Badge
                            pill
                            color="red"
                            className="ms-3 fs-6 fw-400 align-middle d-inline-block"
                        >
                            {totalItemsCount}
                        </Badge>
                    </h2>
                    <ServicesList
                        executors={items}
                        isAllExecutorsLoaded={isAllItemsLoaded}
                        onLoadMore={() => loadItems('next')}
                        disabled={isLoading == 'next'}
                        onExecutorDataChange={onItemDataChange}
                    />
                </div>
            )}
        />
    )
}
